import React from 'react';
import { render, screen } from '@testing-library/react';
import IReferenceMaterial from '@/components/interfaces/ReferenceMaterial';
import ReferenceMaterialCard from '../ReferenceMaterialCard';

const referenceMaterial = {
  date_range: '1735–1826',
  has_video: false,
  id: 1,
  link: 'https://example.com/programs/program_id/reference/1',
  medium_image: 'https://example.com/adams.jpg',
  title: 'Adams, John (1735–1826)',
} as IReferenceMaterial;

const renderCard = () => render(
  <ReferenceMaterialCard
    lessonId={10}
    programId={42}
    referenceMaterial={referenceMaterial}
  />,
);

describe('ReferenceMaterialCard', () => {
  it('emits an empty alt on the aria-hidden thumbnail (WCAG 1.1.1)', () => {
    const { container } = renderCard();

    const image = container.querySelector('img');
    expect(image).toHaveAttribute('alt', '');
    expect(image).toHaveAttribute('aria-hidden', 'true');
  });

  it('keeps the accessible name on the navigation link', () => {
    renderCard();

    expect(
      screen.getByRole('link', { name: /Navigate to Adams, John/ }),
    ).toBeInTheDocument();
  });
});
